var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.getMerchant().merchant_type == 'hotel')?_c('HotelGallery'):(_vm.getMerchant().merchant_type == 'ticket' && _vm.getMerchant().is_special_merchant)?_c('TicketGallery'):_c('GeneralGallery')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01224e9c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/general/Gallery.vue
// module id = null
// module chunks = 